<template>
  <div class="wrap">
    <div class="inner">
      <!-- 表单box start -->
      <div class="formBox">
        <form action class="InfoForm">
          <div class="InfoForm_item flex">
            <label for="name" class="commonLabel">
              <span class="red">*</span>
              <i>姓名:</i>
            </label>
            <input
              v-model="formData.userName"
              type="text"
              name="userName"
              id="name"
              placeholder="请你输入姓名"
            />
          </div>

          <div class="InfoForm_item InfoForm_phoneNum flex">
            <label for="phone" class="commonLabel">
              <span class="red">*</span>
              <i>手机号码:</i>
            </label>
            <input v-model="formData.phoneNum" type="text" name="phone" id="phone" maxlength="11" />
          </div>

          <div class="InfoForm_item InfoForm_DocumentType flex">
            <label for="DocumentType" class="commonLabel">
              <span class="red">*</span>
              <i>证件类型:</i>
            </label>
            <div class="select-box">
              <span>{{documentTypeNames}}</span>
              <div class="img-box" @click="handleSelectBox('SYS_CARD_TYPE')">
                <img src="../../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_DocumentNumber flex">
            <label for="DocumentTNumber" class="commonLabel">
              <span class="red">*</span>
              <i>证件号码:</i>
            </label>
            <input
              v-model="formData.idCardNo"
              type="text"
              name="DocumentTNumber"
              id="DocumentTNumber"
            />
          </div>

          <div class="InfoForm_item InfoForm_Sex flex">
            <label for="DocumentSex" class="commonLabel">
              <span class="red">*</span>
              <i>性别:</i>
            </label>
            <div class="select-box">
              <span>{{sexName}}</span>
              <div class="img-box" @click="isSexShow = true">
                <img src="../../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_birthDate flex">
            <label for="Document_birthDate" class="commonLabel">
              <span class="red">*</span>
              <i>出生日期:</i>
            </label>
            <div class="select-box">
              <span>{{formData.birthDate}}</span>
              <div class="img-box" @click="handShowDate">
                <img src="../../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_address flex">
            <label for="address" class="commonLabel">
              <i>地区:</i>
            </label>
            <div class="select-box">
              <span>{{proAddress}}</span>
              <div class="img-box" @click="handleArea">
                <img src="../../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_DetailedAddress flex">
            <label for="DetailedAddress" class="commonLabel">
              <i>详细地址：</i>
            </label>
            <input
              v-model="formData.detailsAddress"
              type="text"
              name="DetailedAddress"
              id="DetailedAddress"
            />
          </div>
        </form>
      </div>
      <!-- 表单box end -->

      <!-- 底部信息 -->
      <div class="bottomInfo">
        <div class="bottomInfoItem bottomInfoItem01">
          <span>*姓名、身份证为挂号有效凭证，添加后不能修改</span>
        </div>

        <div class="bottomInfoItem bottomInfoItem02">
          <span>*部分医院不支持除居民身份证外的其他证件</span>
        </div>
      </div>

      <!-- 底部按钮div区域 -->
      <div class="bottomBtnBox">
        <div class="flex" v-if="personId">
          <div class="bottomBtnBox_item bottomBtnBox_delete">
            <div class="btnContainer deleteContainer">
              <button class="deleteBtn btn" @click="showDelete">删除</button>
            </div>
          </div>

          <div class="bottomBtnBox_item bottomBtnBox_sure">
            <div class="btnContainer sure_btnContainer">
              <button class="sureBtn btn" @click="showAdd">保存</button>
            </div>
          </div>
        </div>
        <div class="btn-one" @click="showAdd" v-else>保存</div>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="shadow" v-if="shadowIsok">
      <!-- 添加弹框 -->
      <div class="sureDialog">
        <div class="containerInfo">
          <div class="title">
            <span>提示</span>
          </div>
          <div class="sureInfo">
            <div class="sureInfo_item sureInfo_item01">
              <span>请确认添加为常用就诊人吗?</span>
            </div>
            <div class="sureInfo_item sureInfo_item02">
              <span>姓名: {{formData.userName}}</span>
            </div>
            <div class="sureInfo_item sureInfo_item03">
              <span>证件号码：{{formData.idCardNo}}</span>
            </div>
          </div>

          <!-- 温馨提示信息 -->
          <div class="Reminder">
            <div class="ReminderInfo_item">
              <span>为防止挂号失败，请确认：</span>
            </div>
            <div class="ReminderInfo_item">
              <span>1、姓名和证件好的真实性和一致性</span>
            </div>
            <div class="ReminderInfo_item">
              <span>
                2、大部分医院婴幼儿可以填写监护人的证件
                号，但部分医院不允许，在挂号时，请详细阅
                读相关提示
              </span>
            </div>
            <div class="ReminderInfo_item">
              <span>3、添加就诊人未满三个月，不可删除"</span>
            </div>
          </div>
        </div>

        <div class="footBtn">
          <div class="foot-left" @click="hideAdd">关闭</div>
          <div class="foot-right" @click="addUser">确定</div>
        </div>
      </div>
    </div>
    <!-- 删除弹框 -->
    <div class="shadow" v-if="deleteIsok">
      <div class="deleteDialog">
        <div class="deleteContainer">
          <div class="title">
            <span>提示</span>
          </div>
          <div class="containerDeleteInfo">
            <span>请确认删除该就诊人吗?</span>
          </div>
        </div>

        <div class="footBtn">
          <div class="foot-left" @click="hideDelete">关闭</div>
          <div class="foot-right" @click="certDelete">确定</div>
        </div>
      </div>
    </div>

    <!-- :anchor="picker.anchor" -->
    <!-- 删除弹框 -->
    <awesome-picker
      ref="areaPicker"
      :colorConfirm="picker.colorConfirm"
      :data="proviceList"
      @confirm="handlePickerArea"
    ></awesome-picker>

    <mask-box
      :isShow="isDocumentTypeShow"
      @handle-close="docuemntTypeClose"
      :dataList="documentType.data"
      title="证件类型"
      @handle-select="documentTypeSelect"
    ></mask-box>

    <mask-box
      :isShow="isSexShow"
      @handle-close="sexClose"
      :dataList="sexList"
      title="性别"
      @handle-select="sexSelect"
    ></mask-box>
    <div id="date">
      <calendar :show.sync="isShowDate" @change="onChange" :defaultDate="formData.birthDate" />
      <!-- <inlineCalendar /> -->
    </div>
  </div>
</template>


<script>
import { getApi, postApi } from '../../api/index.js'
import MaskBox from '../../components/mask-box'
import { setTimeout } from 'timers'
export default {
  components: {
    'mask-box': MaskBox
  },
  data() {
    return {
      birthDate: '',
      isShowDate: false,
      sss: 'single',
      isSexShow: false,
      sexList: [],
      sexName: '',
      // 控制添加 弹框和
      shadowIsok: false,
      // 控制删除弹框
      deleteIsok: false,
      documentType: {},
      documentTypeNames: '',
      isDocumentTypeShow: false,
      picker: {
        colorConfirm: 'rgb(30,135,242)'
        // anchor: [{ index: '17' }, { index: '0' }, { index: '1' }]
      },
      proviceList: [],
      cityList: [],
      areaList: [],
      cityList1: [],
      proAddress: '',
      formData: {
        userName: '',
        phoneNum: '',
        idCardType: '',
        idCardNo: '',
        sexCode: '',
        birthDate: '',
        detailsAddress: '',
        provinceCode: '',
        cityCode: '',
        countyCode: ''
      },
      personId: ''
    }
  },
  created() {
    this.personId = this.$route.query.personId || ''
    if (this.personId) {
      this.getDetail()
    }
    this.getAreaFun()
    this.getDocumentTypeFun()
    this.getSexList()
  },
  methods: {
    getDetail() {
      getApi({ url: '/patient/detail/' + this.personId, query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              let data = res.data
              this.formData.userName = data.userName
              this.formData.phoneNum = data.phoneNum
              this.formData.idCardType = data.idCardType
              this.documentTypeNames = data.idCardTypeStr
              this.formData.idCardNo = data.idCardNo
              this.formData.sexCode = data.sexCode
              this.sexName = data.sexCodeStr
              this.formData.birthDate = data.birthDateStr
              this.formData.detailsAddress = data.detailsAddress
              this.formData.provinceCode = data.provinceCode
              this.formData.cityCode = data.cityCode
              this.formData.countyCode = data.countyCode
              this.proAddress =
                data.provinceName + '-' + data.cityName + '-' + data.countyName
            }
          }
        })
        .catch(res => {
          console.log('获取证件类型失败')
        })
    },
    certDelete() {
      getApi({ url: '/patient/delete/' + this.personId, query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            this.$toast('删除成功')
            this.deleteIsok = false
            setTimeout(() => {
              this.$router.go(-1)
            }, 2000)
          } else {
            this.$toast(res.resMsg || '网络异常，请重试')
          }
        })
        .catch(res => {
          console.log('获取证件类型失败')
        })
    },
    addUser() {
      this.checkData(() => {
        if (this.personId) {
          postApi({
            url: '/patient/update',
            query: { cardUid: this.personId, ...this.formData }
          })
            .then(res => {
              if (res.resCode == 0) {
                this.$toast('修改成功')
                this.shadowIsok = false
                setTimeout(() => {
                  this.$router.go(-1)
                }, 2000)
              } else {
                this.$toast(res.resMsg || '网络异常，请重试')
              }
            })
            .catch(res => {
              // this.$toast(res.data)
            })
        } else {
          postApi({ url: '/patient/add', query: { ...this.formData } })
            .then(res => {
              if (res.resCode == 0) {
                this.$toast('添加成功')
                this.shadowIsok = false
                setTimeout(() => {
                  this.$router.go(-1)
                }, 2000)
              } else {
                this.$toast(res.resMsg || '网络异常，请重试')
              }
            })
            .catch(res => {
              // this.$toast(res.data)
            })
        }
      })
    },
    checkData(callback) {
      if (!this.formData.userName) {
        this.$toast('请输入姓名！')
        return false
      } else if (!this.formData.phoneNum) {
        this.$toast('请输入手机号码！')
        return false
      } else if (!/^1\d{10}$/.test(this.formData.phoneNum)) {
        this.$toast('请输入正确的手机号码！')
        return false
      } else if (!this.formData.idCardType) {
        this.$toast('请选择正确的证件类型！')
        return false
      } else if (!this.formData.idCardNo) {
        this.$toast('请输入正确的证件号码！')
        return false
      } else if (
        this.formData.idCardType == 'IDCARD' &&
        this.formData.idCardNo.length != 18
      ) {
        this.$toast('请输入正确的证件号码！')
        return false
      } else if (!this.formData.sexCode) {
        this.$toast('请选择性别！')
        return false
      } else if (!this.formData.birthDate) {
        this.$toast('请输入出生日期！')
        return false
      } else {
        callback && callback()
      }
    },
    handShowDate() {
      let date = new Date()
      let y = date.getFullYear()
      let m = this.tf(date.getMonth() + 1)
      let d = this.tf(date.getDate())
      let time = y + '-' + m + '-' + d
      // this.isShowDate = true
      this.$picker.show({
        type: 'datePicker',
        date: this.formData.birthDate || '1990-01-01',
        endTime: time, //截至时间
        startTime: '1880-01-01', //开始时间
        onOk: date => {
          this.formData.birthDate = date
        }
      })
    },
    tf(i) {
      return (i < 10 ? '0' : '') + i
    },
    onChange(date) {
      this.formData.birthDate = date.format('YYYY-MM-DD')
      this.isShowDate = false
    },
    sexClose() {
      this.isSexShow = false
    },
    showDelete() {
      this.shadowIsok = false
      this.deleteIsok = true
    },
    hideDelete() {
      this.shadowIsok = false
      this.deleteIsok = false
    },
    showAdd() {
      this.checkData(() => {
        this.shadowIsok = true
      })
    },
    hideAdd() {
      this.shadowIsok = false
    },
    handleArea() {
      this.$refs.areaPicker.show()
    },
    sexSelect(item) {
      // console.log(item);
      this.sexName = item.dicName
      this.formData.sexCode = item.dicCode
      this.isSexShow = false
    },
    getSexList() {
      // this.isDocumentTypeShow = true;
      getApi({ url: '/common/dict/SYS_SEX', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            this.sexList = res.data
          }
        })
        .catch(res => {
          console.log('获取证件类型失败')
        })
    },
    getAreaFun() {
      getApi({ url: '/area/listAll', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              let data = res.data
              data.forEach((v, i) => {
                if (v.areaLayer == '1') {
                  this.proviceList.push({
                    id: v.areaCode,
                    value: v.areaName,
                    level: v.areaLayer,
                    sheng: v.areaPcode
                  })
                }
                if (v.areaLayer == '2') {
                  this.cityList1.push({
                    id: v.areaCode,
                    value: v.areaName,
                    level: v.areaLayer,
                    sheng: v.areaPcode
                  })
                }
              })
              this.proviceList.forEach((v, i) => {
                let arr = []
                data.forEach((v1, i1) => {
                  if (v1.areaLayer == 2 && v1.areaPcode == v.id) {
                    arr.push({
                      id: v1.areaCode,
                      value: v1.areaName,
                      level: v1.areaLayer,
                      sheng: v1.areaPcode
                    })
                  }
                })
                this.cityList[v.id] = arr
              })
              this.cityList1.forEach((v, i) => {
                var arr = []
                data.forEach((v1, i1) => {
                  if (
                    v1.areaLayer == 3 &&
                    ('' + v1.areaCode).substr(0, 4) == v.id
                  ) {
                    arr.push({
                      id: v1.areaCode,
                      value: v1.areaName,
                      level: v1.areaLayer,
                      sheng: v1.areaPcode
                    })
                  }
                })
                this.areaList[v.id] = arr
              })
              this.proviceList.forEach(province => {
                province.children = this.cityList[province.id]
                province.children.forEach(city => {
                  city.children = this.areaList[city.id]
                })
              })
            }
          }
        })
        .catch(res => {})
    },

    getDocumentTypeFun() {
      getApi({ url: '/common/dict/SYS_CARD_TYPE', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            this.documentType = res
          }
        })
        .catch(res => {
          console.log('获取证件类型失败')
        })
    },

    docuemntTypeClose() {
      this.isDocumentTypeShow = false
    },

    documentTypeSelect(item) {
      this.formData.idCardType = item.dicCode
      this.documentTypeNames = item.dicName
      this.isDocumentTypeShow = false
    },

    handleSelectBox(str) {
      if (str == 'SYS_CARD_TYPE') {
        this.isDocumentTypeShow = true
      }
    },

    handlePickerArea(v) {
      this.proAddress = v[0].value + '-' + v[1].value + '-' + v[2].value
      var pObj = this.proviceList[v[0].index]
      this.formData.provinceCode = pObj.id || ''
      var cObj = pObj.children[v[1].index]
      this.formData.cityCode = cObj.id || ''
      var aObj = cObj.children[v[2].index]
      this.formData.countyCode = aObj.id || ''
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
}
.inner {
  // padding: 0 0.26rem;
  box-sizing: border-box;
  width: 100%;
}

.bottomInfo {
  box-sizing: border-box;
  padding: 0.32rem 0.26rem 0;
  width: 100%;

  .bottomInfoItem {
    width: 100%;

    span {
      color: rgb(153, 153, 153);
      font-size: 0.24rem;
      letter-spacing: -0.006rem;
    }
  }
}
.select-box {
  // padding-left: 2rem;
  text-align: right;
  padding-right: 0.33rem;
  width: 60%;
  height: 0.9rem;
  border: 0rem transparent solid;
  line-height: 0.9rem;
  font-size: 0.3rem;
  .img-box {
    padding-left: 0.16rem;
    display: inline-block;
  }
  img {
    width: 0.28rem;
  }
}

.bottomBtnBox {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.22rem;
  line-height: 1.22rem;
  background-color: rgb(255, 255, 255);
  text-align: center;
  .btn-one {
    display: inline-block;
    width: 4rem;
    height: 0.88rem;
    background: #4dcd70;
    line-height: 0.88rem;
    border-radius: 0.3rem;
    color: #fff;
    font-size: 0.3rem;
    text-align: center;
  }
  .bottomBtnBox_item {
    width: 50%;
    height: 100%;
    .btnContainer {
      margin: 0 auto;
      width: 3rem;
      height: 0.88rem;
      .deleteBtn {
        background-color: rgb(153, 153, 153);
      }
      .sureBtn {
        background-color: rgb(77, 205, 112);
      }

      .btn {
        width: 100%;
        height: 100%;
        border-radius: 0.2rem;
        border: 0px solid transparent;
        font-size: 0.3rem;
        color: rgb(255, 255, 255);
      }
    }
  }
}

.formBox {
  width: 100%;
  .InfoForm {
    width: 100%;
  }

  .InfoForm_address {
    margin-top: 0.16rem;
  }

  .InfoForm_item {
    input {
      // padding-left: 2rem;
      text-align: right;
      padding-right: 0.33rem;
      width: 60%;
      height: 0.9rem;
      border: 0rem transparent solid;
      font-size: 0.3rem;
    }

    width: 100%;
    background-color: #fff;
    border-bottom: rgb(238, 238, 238) solid 0.02rem;

    .commonLabel {
      padding-left: 0.26rem;
      display: block;
      width: 40%;
      height: 100%;
      // text-align: center;
      line-height: 0.9rem;
      letter-spacing: -0.007rem;
      font-size: 0.3rem;
      span {
        color: rgb(255, 0, 0);
        font-size: 0.3rem;
      }
      i {
        font-size: 0.3rem;
      }
    }
  }
}
// 遮罩阴影
.shadow {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
  box-sizing: border-box;
  // padding: 4.16rem 0.97rem 0 0.93rem;
  .sureDialog {
    width: 5.6rem;
    // height: 5.8rem;
    background-color: #fff;
    margin: 1.45rem auto;
    overflow: hidden;
    // padding: 0 0.74rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    .containerInfo {
      overflow: hidden;
      padding: 0rem 0.41rem;

      .title {
        font-size: 0.36rem;
        text-align: center;
        color: rgb(0, 0, 0);
        margin-top: 0.31rem;
      }
      .sureInfo {
        width: 100%;
        .sureInfo_item {
          width: 100%;
          margin-top: 0.1rem;
          span {
            font-size: 0.3rem;
            color: rgb(51, 51, 51);
          }
        }
      }

      .Reminder {
        margin-top: 0.2rem;
        width: 100%;
        .ReminderInfo_item {
          width: 100%;
          span {
            color: rgb(153, 153, 153);
            font-size: 0.24rem;
          }
        }
      }
    }
    .footBtn {
      width: 100%;
      height: 1rem;
      box-sizing: border-box;
      border-top: 0.01rem solid #eee;
      // border-bottom: .01rem solid #eee;
      margin-top: 0.35rem;
      line-height: 1rem;
      div {
        display: inline-block;
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        text-align: center;
      }
      .foot-left {
        border-right: 0.01rem solid #eee;
        color: rgb(0, 0, 0);
      }
      .foot-right {
        color: rgb(0, 194, 0);
      }
    }
  }
  .deleteDialog {
    width: 5.6rem;
    // height: 5.8rem;
    background-color: #fff;
    margin: 3.4rem auto;
    overflow: hidden;
    // padding: 0 0.74rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    .deleteContainer {
      overflow: hidden;
      width: 100%;
      text-align: center;
      .title {
        font-size: 0.36rem;
        color: rgb(0, 0, 0);
        margin-top: 0.5rem;
      }
      .containerDeleteInfo {
        font-size: 0.3rem;
        color: rgb(153, 153, 153);
        margin-top: 0.3rem;
      }
    }
    .footBtn {
      width: 100%;
      height: 1rem;
      box-sizing: border-box;
      border-top: 0.01rem solid #eee;
      // border-bottom: .01rem solid #eee;
      margin-top: 0.35rem;
      line-height: 1rem;
      div {
        display: inline-block;
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        text-align: center;
      }
      .foot-left {
        border-right: 0.01rem solid #eee;
        color: rgb(0, 0, 0);
      }
      .foot-right {
        color: rgb(0, 194, 0);
      }
    }
  }
}
</style>